// duration of each slides appearance in ms
const duration = 5000

// gather in our slides and get length to loop through
let slides = document.getElementsByClassName('ra-image-slider-slide')
let slidesLength = slides.length

// our main loop: changes the slide by moving the hidden class along
function rotateSlides(index) {
	changeImageSliderSlide(index)
		
	// check the index is in range; if not, reset to 0
	if((slidesLength - 1) === index) {
		index = 0
	} else {
			index++
	}

	// loop the function by recalling on a timeout
	setTimeout(rotateSlides, duration, index)
}

function changeImageSliderSlide(index) {
	// add the hidden class to all slides
	slides.forEach( slide => {
			slide.classList.add('ra-image-slider-slide-hidden')
	})
	// then remove from the one we show
	slides[index].classList.remove('ra-image-slider-slide-hidden')
}

// run function on timeout with 0 index
setTimeout(rotateSlides, duration, 0)

